import * as React from 'react'

import { Route, Routes } from 'react-router-dom'
import { Box } from '@mui/material'
import PageNotFound from './components/PageNotFound'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import InputForm from './components/InputForm'
import RequestBase from './components/RequestBase'
import LogoutPage from './components/LogoutPage'
import RedirectPage from './components/RedirectPage'
// const env = process.env['REACT_APP_ENV'] ?? 'dev'

const App = () => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      flexWrap={'nowrap'}
      height={'98vh'}>
      <Header flex={0} />
      <Box flex={1} height={'2000px'} overflow={'auto'} paddingTop={5}>
        <Routes>
          <Route path="/campaign/confirm" element={<RequestBase />}>
            <Route path="/campaign/confirm/" element={<InputForm />} />
          </Route>

          <Route path="/campaign/redirect/" element={<RedirectPage />} />

          <Route path="/logout" element={<LogoutPage />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Box>
      <Footer flex={0} />
    </Box>
  )
}

export default App
